import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MessageBoxWithIcon = _resolveComponent("MessageBoxWithIcon");
    const _component_AlarmSelected = _resolveComponent("AlarmSelected");
    const _component_AffectedComponent = _resolveComponent("AffectedComponent");
    const _component_Duration = _resolveComponent("Duration");
    const _component_Reason = _resolveComponent("Reason");
    const _component_RequiredFields = _resolveComponent("RequiredFields");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_MessageBoxWithIcon, {
            class: "mb-4",
            variant: _ctx.BootstrapVariant.INFO,
            "icon-name": "info",
            "icon-title": _ctx.tr('common.INFORMATION')
        }, {
            message: _withCtx(() => [
                _createElementVNode("span", {
                    innerHTML: _ctx.tr('viiu.componentMuting.MUTE_AFFECTED_COMPONENTS_INFO_BOX')
                }, null, 8, _hoisted_1)
            ]),
            _: 1
        }, 8, ["variant", "icon-title"]),
        _createVNode(_component_AlarmSelected, {
            class: "mb-4",
            "alarm-type-id": _ctx.modelValue.alarmInformation.alarmTypeId,
            "alarm-type": _ctx.modelValue.alarmInformation.alarmType,
            "alarm-id": _ctx.modelValue.alarmInformation.alarmId
        }, null, 8, ["alarm-type-id", "alarm-type", "alarm-id"]),
        _createVNode(_component_AffectedComponent, {
            class: "mb-4",
            "should-cascade": _ctx.shouldCascade,
            "component-id": _ctx.modelValue.mutedComponent.componentId,
            "component-type": _ctx.modelValue.mutedComponent.componentType,
            "system-id": _ctx.modelValue.systemId
        }, null, 8, ["should-cascade", "component-id", "component-type", "system-id"]),
        _createVNode(_component_Duration, {
            "model-value": [_ctx.modelValue.start, _ctx.modelValue.end],
            class: "mb-4",
            "onUpdate:modelValue": _ctx.updateDuration
        }, null, 8, ["model-value", "onUpdate:modelValue"]),
        _createVNode(_component_Reason, {
            "model-value": _ctx.modelValue.reason,
            "alarm-type": _ctx.modelValue.alarmInformation.alarmType,
            "alarm-id": _ctx.modelValue.alarmInformation.alarmId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:model-value', { ..._ctx.modelValue, reason: value }))
        }, null, 8, ["model-value", "alarm-type", "alarm-id"]),
        _createVNode(_component_RequiredFields, { class: "mt-4" })
    ], 64));
}
